import type { NodeEntry } from 'slate';

import type { RenderInlineOptions } from './inline';
import { renderInlineFns } from './inline';
import { Queries } from '../../slate-api';
import type { RenderModelLink } from '../../slate-api';
import { parseLink } from '../../util';
import type { RenderContext } from '../engine/render-context';

export function renderLink(
  renderContext: RenderContext,
  rMLinkEntry: NodeEntry<RenderModelLink>,
  options: RenderInlineOptions
) {
  const { editor } = renderContext;
  const isReadOnly = renderContext.withContext('isReadOnly');
  const [rMLink, rMLinkPath] = rMLinkEntry;
  const { href } = rMLink;
  const width = Queries.getRMNodeWidthPx(editor, rMLinkEntry);
  const height = Queries.getRMNodeHeightPx(editor, rMLinkEntry);
  const parsedLink = parseLink(href);

  renderContext.renderChildren(rMLinkEntry, renderInlineFns, options);

  /**
   * Style the link as clickable if we're in read-only mode; the only reason we don't do so in
   * editing mode is because the user can edit the text of the link, so the text cursor is more
   * appropriate.
   */
  if (isReadOnly)
    renderContext.setMouseCursor(0, 0, width, height, {
      cursor: 'pointer',
      key: `${rMLinkPath}-cursor`,
    });

  if (parsedLink.type !== 'error')
    renderContext.drawPDFLink(0, 0, width, height, {
      destination: parsedLink.type === 'bookmark' ? parsedLink.bookmark : parsedLink.href,
      linkType: parsedLink.type,
    });
}
